import {shallowRef} from 'vue';
import {bus} from '@/core/plugins/bus';

const QUERY_UPDATE = 'query-update';
const QUERY_LIST_UPDATE = 'query-list-update';

const callbacks = shallowRef({
    [QUERY_UPDATE]: [],
    [QUERY_LIST_UPDATE]: [],
});

export default {  
    install: () => {
        function logEvent(eventName) {
            console.log(`Fired event name ${eventName}`);
        }

        for (const eventName of Object.keys(callbacks.value)) {
            bus.on(eventName, () => {
                if (callbacks.value[eventName].length) {
                    Promise.allSettled(callbacks.value[eventName].map((callback) => callback()));
                }
                
                logEvent(eventName);
            });
        }
    },
};

export const useQueryBus = () => {
    function queryUpdate() {
        bus.emit(QUERY_UPDATE);
    }

    function onQueryUpdate(callback) {
        callbacks.value[QUERY_UPDATE].push(callback);
    }

    function listUpdate() {
        bus.emit(QUERY_LIST_UPDATE);
    }

    function onListUpdate(callback) {
        callbacks.value[QUERY_LIST_UPDATE].push(callback);
    }

    function resetEvents() {
        for (const eventName of Object.keys(callbacks.value)) {
            callbacks.value[eventName].splice(0, callbacks.value[eventName].length);
        }

        // TODO Refaching
        // bus.all.clear();
    }

    return {
        queryUpdate,
        onQueryUpdate,
        listUpdate,
        onListUpdate,
        resetEvents,
    };
};
